import React from 'react';
import { Grid, TextField } from '@mui/material';
import { FaClipboardList } from 'react-icons/fa';

const OrdenDatos = ({ form, onChange }) => {
  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaClipboardList /> DATOS DE LA ORDEN</div>
      <div className="card-body">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Fecha de ingreso"
              type="date"
              name="fecha_recepcion"
              value={form.fecha_recepcion}
              onChange={onChange}
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Fecha de entrega"
              type="date"
              name="fecha_entrega"
              value={form.fecha_entrega}
              onChange={onChange}
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default OrdenDatos;
